// import React, { useState, useContext, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import axios from '../axiosAlertConfig';
// import { toast } from 'react-toastify';
// import { UserContext } from '../../userAlertContext';
// import incidentAlertLogo from './INCIDENTALERTLIGHTTRANS.png';
// import {
//   clearMfaReturnTo,
//   extractIncidentIDFromPath,
//   getMfaReturnTo,
// } from '../../utils/incidentDeepLink';

// const pageStyle = {
//   minHeight: '100vh',
//   backgroundColor: '#fde8e8',
//   backgroundImage: `linear-gradient(rgba(253, 232, 232, 0.84), rgba(253, 232, 232, 0.84)), url(${incidentAlertLogo})`,
//   backgroundRepeat: 'no-repeat, no-repeat',
//   backgroundPosition: 'center center, center center',
//   backgroundSize: 'cover, clamp(340px, 62vw, 760px) auto',
//   padding: '1px 16px',
// };

// export default function MfaVerification() {
//   const { user, setUser } = useContext(UserContext);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const returnTo = getMfaReturnTo(location);

//   const [code, setCode] = useState('');
//   const [error, setError] = useState('');
//   const [sending, setSending] = useState(false);

//   const accountID = user?.accountID || user?.iAccountID || null;
//   const userID = user?.userID || user?.iUserID || null;

//   // Leave MFA only when the current MFA state is valid for the saved destination.
//   useEffect(() => {
//     if (!user?.isAuthenticated || user?.isMfaAuthenticated !== true) return;

//     const mode = user?.mfaAuthenticationMode || '';
//     const returnIncidentID = extractIncidentIDFromPath(returnTo);
//     const bypassIncidentID = String(user?.mfaEmergencyIncidentID || '').trim();
//     const emergencyBypassMatches =
//       mode === 'emergency-incident' &&
//       returnIncidentID &&
//       returnIncidentID === bypassIncidentID;

//     if (mode !== 'emergency-incident' || emergencyBypassMatches) {
//       clearMfaReturnTo();
//       navigate(returnTo, { replace: true });
//     }
//   }, [
//     user?.isAuthenticated,
//     user?.isMfaAuthenticated,
//     user?.mfaAuthenticationMode,
//     user?.mfaEmergencyIncidentID,
//     navigate,
//     returnTo,
//   ]);

//   const handleCodeChange = (e) => {
//     const input = e.target.value;
//     if (/^\d{0,6}$/.test(input)) setCode(input);
//   };

//   const sendAuthCode = async (method /* 'sms' | 'email' */) => {
//     if (sending) return;
//     setSending(true);
//     setError('');

//     try {
//       const payload = {
//         method,
//         userID,
//         iAccountID: accountID,
//       };

//       const { data } = await axios.post('/request-mfa-code', payload, {
//         withCredentials: true,
//       });

//       if (data?.success) {
//         toast.info(data?.message || 'Verification code sent.');
//       } else {
//         toast.error(data?.message || 'Failed to send MFA code.');
//       }
//     } catch (err) {
//       console.error('[IncidentAlert MFA] request-mfa-code error:', err);
//       toast.error('Error sending MFA code.');
//     } finally {
//       setSending(false);
//     }
//   };

//   const handleVerify = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (code.length !== 6) {
//       setError('Please enter a 6-digit code.');
//       toast.warn('Please enter a 6-digit code.');
//       return;
//     }

//     try {
//       const { data } = await axios.post(
//         '/verify-mfa',
//         {
//           iAccountID: accountID,
//           userID,
//           code,
//         },
//         { withCredentials: true }
//       );

//       if (data?.success) {
//         setUser((prev) => ({
//           ...prev,
//           isMfaAuthenticated: true,
//           mfaAuthenticationMode: 'trusted',
//           mfaEmergencyIncidentID: null,
//         }));
//         clearMfaReturnTo();
//         toast.success('MFA verified!');
//         navigate(returnTo, { replace: true });
//       } else if (data?.logout) {
//         toast.error('Too many attempts. Logging out.');
//         window.location.reload();
//       } else {
//         setError(data?.message || 'Verification failed. Try again.');
//         toast.error(data?.message || 'Verification failed.');
//       }
//     } catch (err) {
//       console.error('[IncidentAlert MFA] verify-mfa error:', err);
//       setError('Network error, please try again.');
//       toast.error('Network error, please try again.');
//     }
//   };

//   return (
//     <div style={pageStyle}>
//       <div style={{ maxWidth: 420, margin: '80px auto', textAlign: 'center' }}>
//         <h2>MFA Verification</h2>

//         {error && <p style={{ color: 'salmon' }}>{error}</p>}

//         <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 14 }}>
//           <button
//             type="button"
//             onClick={() => sendAuthCode('sms')}
//             disabled={sending}
//             style={{ padding: '10px 12px', cursor: sending ? 'not-allowed' : 'pointer' }}
//           >
//             {sending ? 'Sending…' : 'Text me a code'}
//           </button>

//           <button
//             type="button"
//             onClick={() => sendAuthCode('email')}
//             disabled={sending}
//             style={{ padding: '10px 12px', cursor: sending ? 'not-allowed' : 'pointer' }}
//           >
//             {sending ? 'Sending…' : 'Email me a code'}
//           </button>
//         </div>

//         <form onSubmit={handleVerify}>
//           <input
//             type="text"
//             placeholder="XXXXXX"
//             maxLength={6}
//             value={code}
//             onChange={handleCodeChange}
//             inputMode="numeric"
//             autoComplete="one-time-code"
//             style={{ marginBottom: 10, width: '100%', padding: 10, textAlign: 'center', fontSize: 18 }}
//           />

//           <button type="submit" style={{ width: '100%', padding: '10px 0' }}>
//             Verify Code
//           </button>
//         </form>

//         <p style={{ marginTop: 14, fontSize: 13, opacity: 0.85 }}>
//           For your security, do not complete MFA on a public/shared device.
//         </p>
//       </div>
//     </div>
//   );
// }

import React, { useState, useContext, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../axiosAlertConfig';
import { toast } from 'react-toastify';
import { UserContext } from '../../userAlertContext';
import incidentAlertLogo from './INCIDENTALERTLIGHTTRANS.png';
import {
  clearMfaReturnTo,
  extractIncidentIDFromPath,
  getMfaReturnTo,
} from '../../utils/incidentDeepLink';

const MFA_LINK_CHALLENGE_KEY = 'incidentAlertOneTapMfaChallengeID';
const MFA_LINK_DELIVERY_KEY = 'incidentAlertOneTapMfaDeliveryMethods';

const pageStyle = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fde8e8',
  backgroundImage: `linear-gradient(rgba(253, 232, 232, 0.84), rgba(253, 232, 232, 0.84)), url(${incidentAlertLogo})`,
  backgroundRepeat: 'no-repeat, no-repeat',
  backgroundPosition: 'center center, center center',
  backgroundSize: 'cover, clamp(340px, 62vw, 760px) auto',
  padding: '28px 16px',
  boxSizing: 'border-box',
};

const contentStyle = {
  width: '100%',
  maxWidth: 440,
  margin: 0,
  textAlign: 'center',
};

const codeSentNoticeStyle = {
  width: 'max-content',

  // Keeps the message on one line when there is enough screen width,
  // but prevents it from extending beyond the mobile viewport.
  maxWidth: 'calc(100vw - 32px)',

  marginBottom: 18,
  padding: '12px 10px',

  color: '#003366',
  textAlign: 'center',
  fontSize: '2.25rem',
  fontWeight: 700,
  lineHeight: 1.25,
  boxSizing: 'border-box',

  // Allow wrapping ONLY when maxWidth forces it on a smaller screen.
  whiteSpace: 'normal',

  // Center this wider notice over the 440px MFA box.
  position: 'relative',
  left: '50%',
  transform: 'translateX(-50%)',
};

const codeSentMethodStyle = {
  display: 'inline-block',
  backgroundColor: '#003366',
  color: '#ffffff',
  padding: '2px 6px',
  borderRadius: '4px',

  // Never split PHONE or EMAIL themselves.
  whiteSpace: 'nowrap',
};

const oneTapBoxStyle = {
  marginBottom: 18,
  padding: 16,
  background: 'rgba(255,255,255,0.94)',
  border: '2px solid #b00020',
  borderRadius: 8,
  boxShadow: '0 8px 22px rgba(0,0,0,.12)',
  color: '#3a0b12',
  lineHeight: 1.45,
};

const manualBoxStyle = {
  padding: 18,
  background: 'rgba(255,255,255,0.92)',
  border: '1px solid rgba(176,0,32,.4)',
  borderRadius: 8,
  boxShadow: '0 8px 22px rgba(0,0,0,.10)',
};

const actionButtonStyle = {
  padding: '10px 12px',
  borderRadius: 5,
  border: '1px solid #8b0019',
  background: '#fff',
  color: '#6f0014',
  fontWeight: 700,
};

const buttonDividerStyle = {
  width: '100%',
  borderTop: '1px solid rgba(139, 0, 25, 0.35)',
  margin: '50px 0 10px',
};

function readStoredDeliveryMethods() {
  try {
    const parsed = JSON.parse(
      sessionStorage.getItem(MFA_LINK_DELIVERY_KEY) || '[]'
    );
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function deliveryLabel(methods) {
  const hasSms = methods.includes('sms');
  const hasEmail = methods.includes('email');
  if (hasSms && hasEmail) return 'by text and email';
  if (hasSms) return 'by text';
  if (hasEmail) return 'by email';
  return 'to your saved contact methods';
}

/*
 * ONE-TAP MFA TEMPORARILY DISABLED.
 * Keep this helper commented so it can be restored later without rebuilding it.
function resendButtonLabel(methods) {
  const hasSms = methods.includes('sms');
  const hasEmail = methods.includes('email');
  if (hasSms && hasEmail) return 'Resend Text and Email One-Tap Links';
  if (hasSms) return 'Resend Text One-Tap Link';
  if (hasEmail) return 'Resend Email One-Tap Link';
  return 'Resend One-Tap Link';
}
*/

function getErrorDetails(error) {
  const response = error?.response ||
    (Number.isFinite(Number(error?.status)) ? error : null);

  return {
    status: Number(response?.status) || 0,
    data: response?.data || null,
    message:
      response?.data?.message ||
      error?.message ||
      'An unexpected error occurred.',
  };
}

export default function MfaVerification() {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = getMfaReturnTo(location);

  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  // Keep the existing challenge ID only so a pending legacy one-tap challenge
  // can still be cancelled after successful six-digit verification.
  // One-tap polling, display, and resend controls are commented out below.
  const [challengeID] = useState(() =>
    String(
      sessionStorage.getItem(MFA_LINK_CHALLENGE_KEY) ||
      location.state?.oneTapChallengeID ||
      ''
    ).trim()
  );
  const [deliveryMethods] = useState(() => {
    const storedMethods = readStoredDeliveryMethods();
    if (storedMethods.length) return storedMethods;

    const fromState = location.state?.oneTapDeliveryMethods;
    return Array.isArray(fromState) ? fromState : [];
  });

  /* ONE-TAP MFA TEMPORARILY DISABLED.
  const [resendingOneTap, setResendingOneTap] = useState(false);
  const [oneTapStatus, setOneTapStatus] = useState(
    challengeID ? 'waiting' : 'unavailable'
  );
  */

  const accountID = user?.accountID || user?.iAccountID || null;
  const userID = user?.userID || user?.iUserID || null;

  const clearOneTapState = useCallback(() => {
    sessionStorage.removeItem(MFA_LINK_CHALLENGE_KEY);
    sessionStorage.removeItem(MFA_LINK_DELIVERY_KEY);
  }, []);

  const finishTrustedLogin = useCallback((serverUser, message) => {
    const trustedUser = {
      ...(user || {}),
      ...(serverUser || {}),
      isAuthenticated: true,
      isMfaAuthenticated: true,
      mfaAuthenticationMode: 'trusted',
      mfaEmergencyIncidentID: null,
    };

    setUser(trustedUser);
    sessionStorage.setItem('userInfo', JSON.stringify(trustedUser));
    clearOneTapState();
    clearMfaReturnTo();

    if (message) toast.success(message);
    navigate(returnTo, { replace: true });
  }, [clearOneTapState, navigate, returnTo, setUser, user]);

  useEffect(() => {
    if (!user?.isAuthenticated || user?.isMfaAuthenticated !== true) return;

    const mode = user?.mfaAuthenticationMode || '';
    const returnIncidentID = extractIncidentIDFromPath(returnTo);
    const bypassIncidentID = String(user?.mfaEmergencyIncidentID || '').trim();
    const emergencyBypassMatches =
      mode === 'emergency-incident' &&
      returnIncidentID &&
      returnIncidentID === bypassIncidentID;

    if (mode !== 'emergency-incident' || emergencyBypassMatches) {
      clearOneTapState();
      clearMfaReturnTo();
      navigate(returnTo, { replace: true });
    }
  }, [
    user?.isAuthenticated,
    user?.isMfaAuthenticated,
    user?.mfaAuthenticationMode,
    user?.mfaEmergencyIncidentID,
    clearOneTapState,
    navigate,
    returnTo,
  ]);

  /*
   * ONE-TAP MFA TEMPORARILY DISABLED.
   * Do not poll for approval links while six-digit-code-only MFA is active.
  useEffect(() => {
    // Pause the old challenge poll while a replacement is being created.
    // A late response for the invalidated challenge must not overwrite the
    // replacement challenge state.
    if (
      !challengeID ||
      oneTapStatus !== 'waiting' ||
      resendingOneTap
    ) {
      return undefined;
    }

    let cancelled = false;
    let timer = null;

    const poll = async () => {
      try {
        const { data } = await axios.get(
          `/LoginNew/one-tap-mfa-status/${encodeURIComponent(challengeID)}`,
          { params: { clientApp: 'IncidentAlert' }, withCredentials: true }
        );

        if (cancelled) return;

        if (data?.approved === true) {
          setOneTapStatus('approved');
          finishTrustedLogin(data.user, 'MFA completed.');
          return;
        }

        timer = window.setTimeout(poll, 1500);
      } catch (pollError) {
        if (cancelled) return;

        const details = getErrorDetails(pollError);

        if (details.status === 410 && details.data?.resendAllowed === true) {
          setOneTapStatus('expired');
          setError('');
          return;
        }

        if ([400, 403, 410].includes(details.status)) {
          setOneTapStatus('unavailable');
          clearOneTapState();
          setError(
            details.message ||
            'The one-tap link is no longer available. Use a backup option below.'
          );
          return;
        }

        timer = window.setTimeout(poll, 2000);
      }
    };

    poll();

    return () => {
      cancelled = true;
      if (timer) window.clearTimeout(timer);
    };
  }, [
    challengeID,
    clearOneTapState,
    finishTrustedLogin,
    oneTapStatus,
    resendingOneTap,
  ]);
  */

  const handleCodeChange = (event) => {
    const input = event.target.value;
    if (/^\d{0,6}$/.test(input)) setCode(input);
  };

  const sendAuthCode = async (method) => {
    if (sending) return;
    setSending(true);
    setError('');

    try {
      const payload = {
        method,
        userID,
        iAccountID: accountID,
      };

      const { data } = await axios.post('/request-mfa-code', payload, {
        withCredentials: true,
      });

      if (data?.success) {
        toast.info(data?.message || 'Verification code sent.');
      } else {
        toast.error(data?.message || 'Failed to send MFA code.');
      }
    } catch (requestError) {
      console.error('[IncidentAlert MFA] request-mfa-code error:', requestError);
      const details = getErrorDetails(requestError);
      toast.error(details.message || 'Error sending MFA code.');
    } finally {
      setSending(false);
    }
  };

  /*
   * ONE-TAP MFA TEMPORARILY DISABLED.
   * The six-digit text/email buttons below replace this resend action.
  const resendOneTapLink = async () => {
    if (!challengeID || resendingOneTap || sending) return;

    setResendingOneTap(true);
    setError('');

    try {
      const { data } = await axios.post(
        '/LoginNew/login-resend-one-tap-mfa',
        {
          challengeID,
          clientApp: 'IncidentAlert',
        },
        { withCredentials: true }
      );

      const replacementChallengeID = String(
        data?.oneTapMfaChallengeID || ''
      ).trim();
      const replacementDeliveryMethods = Array.isArray(
        data?.oneTapMfaDeliveryMethods
      )
        ? data.oneTapMfaDeliveryMethods
        : [];

      if (
        data?.success !== true ||
        data?.sent !== true ||
        !replacementChallengeID
      ) {
        throw new Error(
          data?.message || 'A new one-tap sign-in link could not be sent.'
        );
      }

      sessionStorage.setItem(
        MFA_LINK_CHALLENGE_KEY,
        replacementChallengeID
      );
      sessionStorage.setItem(
        MFA_LINK_DELIVERY_KEY,
        JSON.stringify(replacementDeliveryMethods)
      );

      setChallengeID(replacementChallengeID);
      setDeliveryMethods(replacementDeliveryMethods);
      setCode('');
      setOneTapStatus('waiting');
      toast.info(
        data?.message || 'A new one-tap sign-in link was automatically sent.'
      );
    } catch (resendError) {
      const details = getErrorDetails(resendError);

      if (details.data?.pending === true || details.data?.approved === true) {
        setOneTapStatus('waiting');
      } else if (details.status === 410) {
        setOneTapStatus('unavailable');
      }

      setError(details.message || 'Unable to send a new one-tap sign-in link.');
      toast.error(details.message || 'Unable to send a new one-tap sign-in link.');
    } finally {
      setResendingOneTap(false);
    }
  };
  */

  const handleVerify = async (event) => {
    event.preventDefault();
    setError('');

    if (code.length !== 6) {
      setError('Please enter a 6-digit code.');
      toast.warn('Please enter a 6-digit code.');
      return;
    }

    try {
      const { data } = await axios.post(
        '/verify-mfa',
        {
          iAccountID: accountID,
          userID,
          code,
        },
        { withCredentials: true }
      );

      if (data?.success) {
        if (challengeID) {
          try {
            await axios.post(
              '/LoginNew/cancel-one-tap-mfa',
              { challengeID, clientApp: 'IncidentAlert' },
              { withCredentials: true }
            );
          } catch (cancelError) {
            console.warn(
              '[one-tap MFA IncidentAlert] unable to cancel link after manual verification',
              cancelError
            );
          }
        }

        finishTrustedLogin(null, 'MFA verified!');
      } else if (data?.logout) {
        toast.error('Too many attempts. Logging out.');
        window.location.reload();
      } else {
        setError(data?.message || 'Verification failed. Try again.');
        toast.error(data?.message || 'Verification failed.');
      }
    } catch (verifyError) {
      console.error('[IncidentAlert MFA] verify-mfa error:', verifyError);
      const details = getErrorDetails(verifyError);
      setError(details.message || 'Network error, please try again.');
      toast.error(details.message || 'Network error, please try again.');
    }
  };

  const automaticCodeNoticeVisible = deliveryMethods.length > 0;

  return (
    <div style={pageStyle}>

 

      <div style={contentStyle}>

 <div style={codeSentNoticeStyle}>
  Auth Code Has Been Sent to Your{' '}
  <strong style={codeSentMethodStyle}>
    PHONE
  </strong>{' '}
  and{' '}
  <strong style={codeSentMethodStyle}>
    EMAIL
  </strong>
  .
</div>

  


        {/* Hidden: the page-level MFA title. */}
        {false && <h2>MFA Verification</h2>}

        {/* Hidden: the entire automatic-code notice box. */}
        {false && automaticCodeNoticeVisible && (
          <section style={oneTapBoxStyle} aria-live="polite">
            <h3 style={{ margin: '0 0 8px' }}>Six-Digit Code Sent</h3>
            <div>
              A six-digit verification code was sent automatically{' '}
              <strong>{deliveryLabel(deliveryMethods)}.</strong>
            </div>
            <div style={{ marginTop: 8 }}>
              Enter the most recently sent code below to complete signing in.
            </div>
          </section>
        )}

        <form onSubmit={handleVerify} style={manualBoxStyle}>
          <h3 style={{ margin: '0 0 6px' }}>Enter Six-Digit Auth Code</h3>

          {/* Hidden: the explanatory paragraph above the code field. */}
          {false && (
            <div style={{ marginBottom: 14 }}>
              Enter the code from the automatic text message or email. Use either
              button below to send a new code. A newly sent code replaces the
              previous code.
            </div>
          )}

          {error && <p style={{ color: '#8b0000' }}>{error}</p>}

          <input
            type="text"
            placeholder="XXXXXX"
            maxLength={6}
            value={code}
            onChange={handleCodeChange}
            inputMode="numeric"
            autoComplete="one-time-code"
            style={{
              marginBottom: 10,
              width: '100%',
              padding: 10,
              textAlign: 'center',
              fontSize: 18,
              boxSizing: 'border-box',
            }}
          />

          <button
            type="submit"
            disabled={sending}
            style={{
              width: '100%',
             


  padding: '10px 12px',
  borderRadius: 5,
  border: '1px solid #8b0019',
  background: '#fff',
  color: '#6f0014',
  fontWeight: 700,









              cursor: sending ? 'not-allowed' : 'pointer',
              opacity: sending ? 0.7 : 1,
            }}
          >
            VERIFY CODE
          </button>

          <div style={buttonDividerStyle} aria-hidden="true" />

          <div
            style={{
              display: 'flex',
              gap: 10,
              justifyContent: 'center',
            }}
          >
            <button
              type="button"
              onClick={() => sendAuthCode('sms')}
              disabled={sending}
              style={{
                ...actionButtonStyle,
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.7 : 1,
                flex: 1,
              }}
            >
              {sending ? 'Sending…' : 'Send New Code by Text'}
            </button>

            <button
              type="button"
              onClick={() => sendAuthCode('email')}
              disabled={sending}
              style={{
                ...actionButtonStyle,
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.7 : 1,
                flex: 1,
              }}
            >
              {sending ? 'Sending…' : 'Send New Code by Email'}
            </button>
          </div>
        </form>

        <p style={{ marginTop: 14, fontSize: 13, opacity: 0.85 }}>
          For your security, do not complete MFA on a public/shared device.
        </p>
      </div>
    </div>
  );
}
